/* eslint-disable */
import * as Types from "./types";

import { TypedDocumentNode as DocumentNode } from "@graphql-typed-document-node/core";
export type GqlPublishFormMutationVariables = Types.Exact<{
  formUri: Types.Scalars["ID"]["input"];
  publishNote?: Types.InputMaybe<Types.Scalars["String"]["input"]>;
  applyToInFlight?: Types.InputMaybe<Types.Scalars["Boolean"]["input"]>;
}>;

export type GqlPublishFormMutation = {
  __typename: "Mutation";
  publishForm: {
    __typename: "PublishFormResult";
    createdAt: string;
    operationId: string;
    formVersionUri: string;
  };
};

export const PublishFormDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "publishForm" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "formUri" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "publishNote" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "applyToInFlight" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "publishForm" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "formUri" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "formUri" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "publishNote" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "publishNote" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "applyToInFlight" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "applyToInFlight" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                { kind: "Field", name: { kind: "Name", value: "operationId" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "formVersionUri" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GqlPublishFormMutation,
  GqlPublishFormMutationVariables
>;
